import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, ImagePlus } from "lucide-react";
import { api, imgUrl } from "../../lib/api";

export const ImageField = ({ value, onChange, testid }) => {
  const [uploading, setUploading] = useState(false);
  const ref = useRef(null);
  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { url } = await api("/admin/upload", { method: "POST", form: fd });
      onChange(url);
      toast.success("Immagine caricata.");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };
  return (
    <div>
      <input ref={ref} data-testid={testid} type="file" accept="image/*" onChange={upload} className="hidden" />
      <button type="button" data-testid={`${testid}-button`} onClick={() => ref.current?.click()} className="btn-ghost w-full !py-3 !text-[11px]" disabled={uploading}>
        {uploading ? <Loader2 size={14} className="animate-spin" /> : <ImagePlus size={14} />} {value ? "Sostituisci immagine" : "Carica immagine"}
      </button>
      {value && <img src={imgUrl(value)} alt="Anteprima" className="mt-3 w-full aspect-[4/3] object-cover border border-steel" />}
    </div>
  );
};
